import { Typography } from "@packages/ds";
import styled from "styled-components";

export const InlineText = styled(Typography.BodyText)`
  display: inline;
`;

export const Note = styled(Typography.Label)`
  margin: 16px 0 24px;
`;
